/** @format */
import { Injectable } from '@angular/core';
import { Module } from 'common-typescript/types';
import { LocaleService } from 'sis-common';
import { CreditRangePipe, isDegreeProgramme, isStudyModule } from 'sis-components';

@Injectable()
export class ModuleLabelService {
    constructor(
        private readonly _localeService: LocaleService,
        private readonly _creditRangePipe: CreditRangePipe,
    ) {}

    /**
     * Returns a translated module name with possible target credits (of degree programme or study module).
     */
    createModuleLabel(module: Module): string {
        let moduleLabel: string = this._localeService.localize(module.name) ?? '';

        if (isDegreeProgramme(module) || isStudyModule(module)) {
            const formattedTargetCredits: string = this._creditRangePipe.transform(module.targetCredits);
            if (formattedTargetCredits) {
                moduleLabel += `, ${formattedTargetCredits}`;
            }
        }

        return moduleLabel;
    }
}
